export const stepData = ['基本设置', '奖项设置', '样式设置'];
//活动玩法
export const SLYDER_ADVENTURES = 'SLYDER_ADVENTURES';
//奖品类型
export const REAL_PRIZE = 'REAL_PRIZE';
export const POINT = 'POINT';
export const COUPON = 'COUPON';
export const POSTER = 'POSTER';
export const NO_PRIZE = 'NO_PRIZE';
//领取实物奖品方式
export const POST = 'POST';
export const TAKE_THEIR = 'TAKE_THEIR';
//优惠券类型
//兑换券
export const EXCHANGE_COUPON = 'EXCHANGE_COUPON';

export const prizeLimitData = [
  {
    leftWord: '完善个人信息可获得',
    name: 'completeInfoDrawNum',
    checkName: 'isCompleteInfoDrawEnabled',
  },
  {
    leftWord: '完成学生认证可获得',
    name: 'studentAuthDrawNum',
    checkName: 'isStudentAuthDrawEnabled',
    midWord: '次抽奖，活动期间最多可获得',
    midName: 'studentAuthMaxDrawNum',
  },
  {
    leftWord: '下单可获得',
    name: 'orderDrawNum',
    checkName: 'isOrderDrawEnabled',
    midWord: '次抽奖，活动期间最多可获得',
    midName: 'orderMaxDrawNum',
  },
  {
    leftWord: '每人每天可额外获得',
    name: 'dailyDrawNum',
    checkName: 'dailyDrawNumCheck',
  },
  {
    leftWord: '消耗',
    midWord: '积分可获得',
    name: 'exchangePoint',
    midName: 'exchangePointDrawNum',
    checkName: 'isExchangeDrawNum',
  },
  {
    leftWord: '邀请好友注册成功可获得',
    name: 'shareRegisterDrawNum',
    checkName: 'isRegisterDrawNum',
    midWord: '次抽奖，活动期间每天可获得',
    midName: 'shareRegisterDayMaxDrawNum',
  },
  {
    leftWord: '注册会员可获得',
    name: 'registerDrawNum',
    checkName: 'isRegister',
  },
];
export const userPrizeLimitData = [
  {
    leftWord: '活动期间共可以获得',
    name: 'drawNumLimit',
    checkName: 'drawNumLimitCheck',
  },
  {
    leftWord: '活动期间每人最多抽中',
    name: 'winLimit',
    checkName: 'winLimitCheck',
  },
  {
    leftWord: '每人每天最多抽中',
    name: 'dailyWinLimit',
    checkName: 'dailyWinLimitCheck',
  },
  {
    leftWord: '每人每天最多抽奖',
    name: 'dailyDrawLimit',
    checkName: 'dailyDrawLimitCheck',
  },
];
export const campaignAreaLimit = [
  { value: 'noLimit', label: '不限制' },
  { value: 'limit', label: '限制' },
];
export const campaignAreaLimitReg = [
  { value: 'noLimit', label: '不限制' },
  { value: 'limit', label: '限制' },
];
export const campaignAreaLimitRegConsume = [
  { value: 'noLimit', label: '不限制' },
  { value: 'limit', label: '限制' },
];
export const orderChannelLimit = [
  { value: 'noLimit', label: '不限制' },
  { value: 'limit', label: '限制' },
];
export const campaignAreaList = [
  { name: '上海', value: '1' },
  { name: '广州', value: '2' },
  { name: '天津', value: '3' },
  { name: '上海商业', value: '4' },
  { name: '常州', value: '5' },
  { name: '深圳', value: '6' },
  { name: '郑州', value: '7' },
  { name: '杭州', value: '8' },
  { name: '西安', value: '9' },
  { name: 'ECOMMERCE', value: '10' },
];

export const acceptWayList = [
  { name: '邮寄', value: POST },
  { name: '到店自取', value: TAKE_THEIR },
];
export const memberLevelList = [
  { name: '初履会员', value: '1' },
  { name: '心履会员', value: '2' },
  { name: '优履会员', value: '3' },
  { name: '奢履会员', value: '4' },
];
export const typeList = [
  { name: '满减券', value: 'CASH_COUPON' },
  { name: '折扣券', value: 'DISCOUNT_COUPON' },
  //目前团购券不支持
  // { name: '团购券', value: 'GROUP_COUPON' },
  { name: '兑换券', value: 'EXCHANGE_COUPON' },
  // 满折券
  { name: '满折券', value: 'FULL_DISCOUNT_COUPON' },
];

export const prizeTypeList = [
  { name: '实物奖', value: REAL_PRIZE },
  { name: '积分', value: POINT },
  { name: '优惠券', value: COUPON },
  { name: '海报', value: POSTER },
];

export const prizeTypeListDalian = [
  { name: '实物奖', value: REAL_PRIZE },
  { name: '积分', value: POINT },
  { name: '优惠券', value: COUPON },
];

export const imgList = [
  {
    title: '背景图片设定',
    name: 'backgroundPicUrl',
    size: '建议尺寸',
    SLYDER_ADVENTURES: '750 × 1624',
    SUDOKU: '750 × 1624',
    SCRATCH_CARD: '750 × 1624',
    errorText: '请选择背景图片',
    maxSize: '5242880',
  },
  {
    title: '转盘图片设定',
    name: 'wheelPicUrl',
    size: '建议尺寸',
    SLYDER_ADVENTURES: '606 × 606',
    SUDOKU: '606 × 606',
    SCRATCH_CARD: '606 × 606',
    errorText: '请选择转盘图片',
    maxSize: '5242880',
  },
  {
    title: '开始按钮图片',
    name: 'startBtnPicUrl',
    size: '建议尺寸',
    SLYDER_ADVENTURES: '157 × 191',
    SUDOKU: '157 × 191',
    SCRATCH_CARD: '157 × 191',
    errorText: '请选择开始按钮图片',
    maxSize: '5242880',
  },
];
export const imgListDalian = [
  {
    title: '背景图片设定',
    name: 'backgroundPicUrl',
    size: '建议尺寸',
    SLYDER_ADVENTURES: '600×600',
    SUDOKU: '604×460',
    SCRATCH_CARD: '592×280',
    errorText: '请选择背景图片',
    maxSize: '5242880',
  },
  {
    title: '抽奖背景图片',
    name: 'wheelPicUrl',
    size: '建议尺寸',
    SLYDER_ADVENTURES: '295x267',
    SUDOKU: '453x345',
    SCRATCH_CARD: '296x140',
    errorText: '请选择转盘图片',
    maxSize: '5242880',
  },
  {
    title: '开始按钮图片',
    name: 'startBtnPicUrl',
    size: '建议尺寸',
    SLYDER_ADVENTURES: '130×158',
    SUDOKU: '184×136',
    SCRATCH_CARD: '81x81',
    errorText: '请选择开始按钮图片',
    maxSize: '5242880',
  },
];
export const buttonGroup = [
  {
    imgName: 'btnPicUrl1',
    title: 'btnName1',
    pagePathName: 'btnPagePah1',
    maxSize: '5242880',
  },
  {
    imgName: 'btnPicUrl2',
    title: 'btnName2',
    pagePathName: 'btnPagePah2',
    maxSize: '5242880',
  },
  {
    imgName: 'btnPicUrl3',
    title: 'btnName3',
    pagePathName: 'btnPagePah3',
    maxSize: '5242880',
  },
  {
    imgName: 'btnPicUrl4',
    title: 'btnName4',
    pagePathName: 'btnPagePah4',
    maxSize: '5242880',
  },
  {
    imgName: 'btnWinnerPicUrl',
    title: 'btnName4',
    pagePathName: 'btnWinnerPagePath',
    maxSize: '5242880',
  },
];
//活动状态
export const UNAPPROVED = 'UNAPPROVED'; //待审核
export const NOT_START = 'NOT_START'; //未开始
export const UNDER_WAY = 'UNDER_WAY'; //进行中
export const END = 'END'; //已结束
export const validateThousandNum = (v) => {
  if (!v) {
    return undefined;
  }
  let value = String(v);
  const isCanSplit = value.indexOf(',') >= 0;
  value = isCanSplit ? value.split(',').join('') : value;
  return value;
};
export function debounce(fn, time) {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, time);
  };
}
